import React, { useState, useEffect } from 'react';
import { FiCheck, FiCheckCircle, FiBell, FiMail, FiPhone, FiUser } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { notificationAPI } from '../../services/api';

const NotificationPage = () => {
  const [data, setData] = useState({ notifications: [], unread_count: 0 });
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // 'all' | 'unread' | 'read'

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const params = filter === 'unread' ? { isRead: false } : {};
      const response = await notificationAPI.list(params);
      setData(response.data);
    } catch (error) {
      console.error('Erreur chargement notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [filter]);

  const markRead = async (id) => {
    try {
      await notificationAPI.markAsRead(id);
      fetchNotifications();
    } catch (error) {
      console.error('Erreur marquage lu:', error);
    }
  };

  const markAllRead = async () => {
    try {
      await notificationAPI.markAllAsRead();
      fetchNotifications();
    } catch (error) {
      console.error('Erreur marquage tout lu:', error);
    }
  };

  // Fonction pour obtenir l'icône en fonction du type de notification
  const getNotificationIcon = (notification) => {
    if (notification.title?.includes('contact') || notification.title?.includes('demande')) {
      return <FiUser size={18} color="#2563eb" />;
    }
    if (notification.title?.includes('loyer') || notification.title?.includes('paiement')) {
      return <FiMail size={18} color="#16a34a" />;
    }
    if (notification.title?.includes('ticket') || notification.title?.includes('maintenance')) {
      return <FiBell size={18} color="#dc2626" />;
    }
    return <FiBell size={18} color="#64748b" />;
  };

  return (
    <div style={{ padding: '24px' }}>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FiBell size={24} />
            Notifications
            {data.unread_count > 0 && (
              <span style={{
                background: '#ef4444',
                color: 'white',
                borderRadius: '50%',
                padding: '2px 10px',
                fontSize: 14,
                marginLeft: 8
              }}>
                {data.unread_count}
              </span>
            )}
          </h1>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: 4, background: '#f1f5f9', borderRadius: 8, padding: 4 }}>
            <button
              onClick={() => setFilter('all')}
              style={{
                padding: '6px 16px',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                background: filter === 'all' ? 'white' : 'transparent',
                fontWeight: filter === 'all' ? 600 : 400,
                boxShadow: filter === 'all' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
              }}
            >
              Toutes
            </button>
            <button
              onClick={() => setFilter('unread')}
              style={{
                padding: '6px 16px',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                background: filter === 'unread' ? 'white' : 'transparent',
                fontWeight: filter === 'unread' ? 600 : 400,
                boxShadow: filter === 'unread' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
              }}
            >
              Non lues
            </button>
          </div>
          {data.unread_count > 0 && (
            <button className="btn btn-secondary" onClick={markAllRead}>
              <FiCheckCircle /> Tout marquer lu
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="loading"><div className="spinner" /></div>
      ) : (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-body">
            {data.notifications.length > 0 ? (
              data.notifications.map((n, index) => (
                <div
                  key={n.id}
                  style={{
                    borderBottom: index < data.notifications.length - 1 ? '1px solid var(--border)' : 'none',
                    display: 'flex',
                    gap: 12,
                    alignItems: 'start',
                    background: n.is_read ? 'transparent' : 'var(--primary-light, #eff6ff)',
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 4,
                    transition: 'background 0.2s'
                  }}
                >
                  <div style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    background: n.is_read ? '#f1f5f9' : '#dbeafe',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    {getNotificationIcon(n)}
                  </div>
                  
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 8 }}>
                      <strong style={{ fontSize: 14 }}>{n.title}</strong>
                      {!n.is_read && (
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => markRead(n.id)}
                          style={{ flexShrink: 0 }}
                        >
                          <FiCheck size={14} /> Marquer lu
                        </button>
                      )}
                    </div>
                    <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 4 }}>
                      {n.message}
                    </p>
                    {n.data?.contact_name && (
                      <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '6px', marginTop: '12px', fontSize: 13, border: '1px solid #e2e8f0' }}>
                        <div style={{ marginBottom: 4 }}><strong>Contact :</strong> {n.data.contact_name}</div>
                        {n.data.contact_phone && <div style={{ marginBottom: 4 }}><strong>Tél :</strong> <a href={`tel:${n.data.contact_phone}`} style={{ color: '#2563eb' }}>{n.data.contact_phone}</a></div>}
                        {n.data.contact_email && <div style={{ marginBottom: 4 }}><strong>Email :</strong> <a href={`mailto:${n.data.contact_email}`} style={{ color: '#2563eb' }}>{n.data.contact_email}</a></div>}
                        {n.data.contact_message && <div style={{ marginTop: 8, fontStyle: 'italic', color: '#475569' }}>"{n.data.contact_message}"</div>}
                      </div>
                    )}
                    {(n.announcement_title || n.data?.announcement_title) && (
                      <Link
                        to={`/announcements/${n.announcement_slug || n.data?.announcement_id || n.announcement_id}`}
                        style={{
                          fontSize: 12,
                          color: '#2563eb',
                          textDecoration: 'none',
                          display: 'inline-block',
                          marginTop: 8
                        }}
                      >
                        Voir l'annonce associée →
                      </Link>
                    )}
                    <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginTop: 4 }}>
                      {new Date(n.created_at).toLocaleString('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state" style={{ textAlign: 'center', padding: 48 }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🔔</div>
                <h3 style={{ color: '#64748b' }}>Aucune notification</h3>
                <p style={{ color: '#94a3b8', fontSize: 14 }}>
                  Vous n'avez pas encore de notifications. Les demandes de contact apparaîtront ici.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationPage;